import { Injectable } from '@angular/core';
import { CedClientService } from '../../../../core/services/ced-client.service';
import { map, Observable } from 'rxjs';
import { ICed } from '../../../../core/models/ced.model';
import { Ced } from './ced.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsCedService {
  constructor(private cedClientService: CedClientService) {}

  getCedData(): Observable<Ced[]> {
    return this.cedClientService.getCed().pipe(
      map((ced) => ced.rows),
      map((rows) => rows.map((row) => new Ced(row.id, row.code, row.danger, row.libelle, row.niveauCED, row.displayCode))),
    );
  }

  addCedData(code: string, danger: boolean, libelle: string, niveauCED: string): Observable<InlineResponse> {
    return this.cedClientService.addCed(code, danger, libelle, niveauCED);
  }

  updateCedData(ced: Ced): Observable<InlineResponse> {
    return this.cedClientService.updateCed(ced);
  }
}
